// @flow
import React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import { Card } from 'statsradio/themes/v3/Stylesheet';
import type { DateRange } from 'statsradio/domain/reach';
import MetricsDateRange from './MetricsDateRange';
import ReachMetrics from './ReachMetrics';

const MetricsCard = styled(Card)`
  margin-bottom: ${({ theme }) => theme.V3.metrics.margin.normal}px;
`;

const SMetricsDateRange = styled(MetricsDateRange)`
  padding-top: ${({ theme }) => theme.V3.metrics.margin.large}px;
  padding-bottom: ${({ theme }) => theme.V3.metrics.margin.large}px;
  padding-left: ${({ theme }) => theme.V3.metrics.margin.normal}px;
`;

interface Props {
  dateRange: DateRange;
  cumulativeReach: number;
  averageReach: number;
  averageQuarterHourReach: number;

  t: any;
  theme: any;
}

function MetricsOverview({ dateRange, cumulativeReach, averageReach, averageQuarterHourReach, t, theme }: Props) {
  return (
    <MetricsCard>
      <SMetricsDateRange dateRange={dateRange} />
      <ReachMetrics cumulativeReach={cumulativeReach} averageReach={averageReach} averageQuarterHourReach={averageQuarterHourReach} />
    </MetricsCard>
  );
}

export default translate('metrics')(withTheme(MetricsOverview));



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/v2/components/reachMetricsOverview/MetricsOverview.js